import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { fetchUserGrowth, fetchRevenueGrowth } from "../../api/endpoint";
import axios from "axios";
import { useSelector } from "react-redux";
import Input from "../../components/input";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  categoryPercentage: 0.5,
  barPercentage: 0.6,
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
      text: "User and Revenue Growth",
    },
  },
};

const UserGrowth = () => {
  const { auth } = useSelector((state) => state.login);
  const [labels, setLabels] = useState([]);
  const [revenueData, setRevenueData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [year, setYear] = useState("2025");

  useEffect(() => {
    getUserGrowth();
    getRevenueGrowth();
  }, [year]);

  const getRevenueGrowth = async () => {
    try {
      const apiResponse = await axios.get(fetchRevenueGrowth, {
        params: { year: year },
        headers: { Authorization: `Bearer ${auth}` },
      });
      const months = apiResponse?.data?.map((month) => month?.month);
      setLabels(months);
      const userCount = apiResponse?.data?.map((month) => month?.count);
      setRevenueData(userCount);
    } catch (error) {
      console.error("Error fetching revenue growth", error);
    }
  };

  const getUserGrowth = async () => {
    try {
      const apiResponse = await axios.get(fetchUserGrowth, {
        params: { year: year },
        headers: { Authorization: `Bearer ${auth}` },
      });
      const months = apiResponse?.data?.map((month) => month?.month);
      setLabels(months);
      const userCount = apiResponse?.data?.map((month) => month?.count);
      setUserData(userCount);
    } catch (error) {
      console.error("Error fetching user growth", error);
    }
  };

  const graphData = {
    labels,
    datasets: [
      {
        label: "Users",
        data: userData,
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Revenue",
        data: revenueData,
        borderColor: "rgb(162, 235, 53)",
        backgroundColor: "rgba(162, 235, 53, 0.5)",
      },
    ],
  };

  const currentYear = new Date().getFullYear();
  const startYear = 2020;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => currentYear - i
  );

  // Set default year on mount (if not already set)
  useEffect(() => {
    if (!year) {
      setYear(String(currentYear));
    }
  }, [year, setYear, currentYear]);

  return (
    <div className="h-100 card shadow rounded-4">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">User and Revenue Growth</h5>
          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            className="form-select w-auto"
            style={{ lineHeight: "normal" }}
          >
            <option value="" disabled>
              -- Select Year --
            </option>
            {years.map((y) => (
              <option key={y} value={y}>
                {y}
              </option>
            ))}
          </select>
        </div>

        <Line options={options} data={graphData} />
      </div>
    </div>
  );
};

export default UserGrowth;
